<template>
  <div class="detail-header">
    <i class="iconfont icon-home"/> {{ detail?.ProductName }}
  </div>
  <div class="detail-main">
    <img class="detail-img" :src="detail?.imgUrl" :alt="detail?.ProductName">
    <div class="detail-info">
      <h3 style="line-height: 36px">{{ detail?.ProductName }}</h3>
      <div class="info-item" v-if="detail?.ProductName">Product Name: {{ detail?.ProductName }}</div>
      <div class="info-item" v-if="detail?.ItemCode">Item Code: {{ detail?.ItemCode }}</div>
      <div class="info-item" v-if="detail?.InputVoltage">Input Voltage: {{ detail?.InputVoltage }}</div>
      <div class="info-item" v-if="detail?.Voltage">Voltage: {{ detail?.Voltage }}</div>
      <div class="info-item" v-if="detail?.RatedCurrentofCoaxialCell">Rated Current of Coaxial Cell: {{ detail?.RatedCurrentofCoaxialCell }}</div>
      <div class="info-item" v-if="detail?.InsulationResistance">Insulation Resistance: {{ detail?.InsulationResistance }}</div>
      <div class="info-item" v-if="detail?.ContactResistance">Contact Resistance: {{ detail?.ContactResistance }}</div>
      <div class="info-item" v-if="detail?.InsertandOutTimes">Insert and Out Times: {{ detail?.InsertandOutTimes }}</div>
      <div class="info-item" v-if="detail?.Power">Power: {{ detail?.Power }}</div>
      <div class="info-item" v-if="detail?.MaximumTorque">Maximum Torque: {{ detail?.MaximumTorque }}</div>
      <div class="info-item" v-if="detail?.ExecutionAccuracy">Execution Accuracy: {{ detail?.ExecutionAccuracy }}</div>
      <div class="info-item" v-if="detail?.LaserPower">Laser Power: {{ detail?.LaserPower }}</div>
      <div class="info-item" v-if="detail?.LaserColor">Laser Color: {{ detail?.LaserColor }}</div>
      <div class="info-item" v-if="detail?.DimmingSignal">Dimming Signal: {{ detail?.DimmingSignal }}</div>
      <div class="info-item" v-if="detail?.ColorTemperature">Color Temperature: {{ detail?.ColorTemperature }}</div>
      <div class="info-item" v-if="detail?.Luminance">Luminance: {{ detail?.Luminance }}</div>
      <div class="info-item" v-if="detail?.Interface">Interface: {{ detail?.Interface }}</div>
      <div class="info-item" v-if="detail?.['Voltage/Dimming']">Voltage/Dimming: {{ detail?.['Voltage/Dimming'] }}</div>
      <div class="info-item" v-if="detail?.VideoSignal">Video Signal: {{ detail?.VideoSignal }}</div>
      <div class="info-item" v-if="detail?.VideoResolution">Video Resolution: {{ detail?.VideoResolution }}</div>
      <div class="info-item" v-if="detail?.PhotosensitiveElement">Photosensitive Element: {{ detail?.PhotosensitiveElement }}</div>
      <div class="info-item" v-if="detail?.LensFocalLength">Lens Focal Length: {{ detail?.LensFocalLength }}</div>
      <div class="info-item" v-if="detail?.MinimumIllumination">Minimum Illumination: {{ detail?.MinimumIllumination }}</div>
      <div class="info-item" v-if="detail?.ViewAngleUnderwater">View Angle Underwater: {{ detail?.ViewAngleUnderwater }}</div>
      <div class="info-item" v-if="detail?.MaximumOperatingWaterDepth">Maximum Operating Water Depth: {{ detail?.MaximumOperatingWaterDepth }}</div>
      <div class="info-item" v-if="detail?.MaximumAngularVeloity">Maximum Angular Veloity: {{ detail?.MaximumAngularVeloity }}</div>
      <div class="info-item" v-if="detail?.MaximumPower">Maximum Power: {{ detail?.MaximumPower }}</div>
      <div class="info-item" v-if="detail?.OperatingTemperature">Operating Temperature: {{ detail?.OperatingTemperature }}</div>
      <div class="info-item" v-if="detail?.StorageTemperature">Storage Temperature: {{ detail?.StorageTemperature }}</div>
      <div class="info-item" v-if="detail?.AngleofElevation">Angle of Elevation: {{ detail?.AngleofElevation }}</div>
      <div class="info-item" v-if="detail?.PendulumAngle">Pendulum Angle: {{ detail?.PendulumAngle }}</div>
      <div class="info-item" v-if="detail?.PayloadWeight">Payload Weight: {{ detail?.PayloadWeight }}</div>
      <div class="info-item" v-if="detail?.ConnectorHousingMaterial">Connector Housing Material: {{ detail?.ConnectorHousingMaterial }}</div>
      <div class="info-item" v-if="detail?.HeaderHousingMaterial">Header Housing Material: {{ detail?.HeaderHousingMaterial }}</div>
      <div class="info-item" v-if="detail?.ConnectorPinMaterial">Connector Pin Material: {{ detail?.ConnectorPinMaterial }}</div>
      <div class="info-item" v-if="detail?.InsidePinTrayMaterial">Inside Pin Tray Material: {{ detail?.InsidePinTrayMaterial }}</div>
      <div class="info-item" v-if="detail?.CoverMaterial">Cover Material: {{ detail?.CoverMaterial }}</div>
      <div class="info-item" v-if="detail?.LockCap">Lock Cap: {{ detail?.LockCap }}</div>
      <div class="info-item" v-if="detail?.CoaxialCable">Coaxial Cable: {{ detail?.CoaxialCable }}</div>
      <div class="info-item" v-if="detail?.CoreWire">Core Wire: {{ detail?.CoreWire }}</div>
      <div class="info-item" v-if="detail?.NormalLength">Normal Length: {{ detail?.NormalLength }}</div>
      <div class="info-item" v-if="detail?.Material">Material: {{ detail?.Material }}</div>
      <div class="info-item" v-if="detail?.ComminicationMode">Comminication Mode: {{ detail?.ComminicationMode }}</div>
      <div class="info-item" v-if="detail?.Compensation">Compensation: {{ detail?.Compensation }}</div>
      <div class="info-item" v-if="detail?.InstallWay">Install Way: {{ detail?.InstallWay }}</div>
      <div class="info-item" v-if="detail?.WeightInAir">Weight In Air: {{ detail?.WeightInAir }}</div>
      <div class="info-item" v-if="detail?.WeightInSeawater">Weight In Sea water: {{ detail?.WeightInSeawater }}</div>
      <div class="info-item" v-if="detail?.PowerSupply">Power Supply: {{ detail?.PowerSupply }}</div>
      <div class="info-item" v-if="detail?.PowerRate">Power Rate: {{ detail?.PowerRate }}</div>
      <div class="info-item" v-if="detail?.VideoFrameRate">Video Frame Rate: {{ detail?.VideoFrameRate }}</div>
      <div class="info-item" v-if="detail?.VideoCompressionStandard">Video Compression Standard: {{ detail?.VideoCompressionStandard }}</div>
      <div class="info-item" v-if="detail?.NetworkInterface">Network Interface: {{ detail?.NetworkInterface }}</div>
      <div class="info-item" v-if="detail?.ElectricalInterface">Electrical Interface: {{ detail?.ElectricalInterface }}</div>
      <div class="info-item" v-if="detail?.CoreDefinition">Core Definition: {{ detail?.CoreDefinition }}</div>
      <div class="info-item" v-if="detail?.Size">Size: {{ detail?.Size }}</div>
      <div class="info-item" v-if="detail?.Application">Application: {{ detail?.Application }}</div>



      <div class="info-item" v-if="detail?.Volume">Volume: {{ detail?.Volume }}</div>
      <div class="info-item" v-if="detail?.PressureCompensationRange">Pressure Compensation Range: {{ detail?.PressureCompensationRange }}</div>
      <div class="info-item" v-if="detail?.ResistanceOutput">Resistance Output: {{ detail?.ResistanceOutput }}</div>
      <div class="info-item" v-if="detail?.CurrentSignalOutput">Current Signal Output: {{ detail?.CurrentSignalOutput }}</div>
      <div class="info-item" v-if="detail?.WeightinAirWithoutOil">Weight in Air Without Oil: {{ detail?.WeightinAirWithoutOil }}</div>
      <div class="info-item" v-if="detail?.WeightInAirWithoutOil">Weight in Air Without Oil: {{ detail?.WeightInAirWithoutOil }}</div>
      <div class="info-item" v-if="detail?.BuoyancyinSeawater">Buoyancy in Seawater: {{ detail?.BuoyancyinSeawater }}</div>
      <div class="info-item" v-if="detail?.MaximumOperatingWaterDepth">Maximum Operating Water Depth: {{ detail?.MaximumOperatingWaterDepth }}</div>
    </div>
  </div>

</template>

<script setup lang="ts">
import {useRoute} from "vue-router";
import {productDetail} from "~/data/data";

const route = useRoute()
const arr = route.fullPath.split('/')
const id = arr[arr.length - 1]
const detail: any = productDetail.find(item => item.ItemCode == id)
useHead({
  title: 'product detail',
  meta: [{
    name: 'description',
    content: `product details for ${detail?.ProductName}`
  }]
})
</script>

<style lang="stylus" scoped>
.detail-header
  height 30px
  box-sizing border-box
  border-bottom 1px solid #EEE
  color #1e8bac
  font-size 16px
  display flex
  align-items top

  .icon-home
    margin-right 8px
    color #888

.detail-main
  background #FFF
  margin-top 20px
  display flex
  .detail-img
    width: 450px
    height: 450px
    margin-right 20px
    box-shadow 10px 10px 60px #e3e3e3

  .detail-info
    & > h3
      font-size 28px
      margin-bottom 20px
    .info-item
      text-align left
      line-height 30px
      font-size 16px
      color #666
      font-weight 300
</style>
